// extracted by mini-css-extract-plugin
export var fadeIn = "_i8-1";
export var modalContent = "_i8-3";
export var overlay = "_i8-0";
export var popoverContent = "_i8-2";
export var results = "_i8-5";
export var searchInputWrapper = "_i8-4";